import React from 'react'

export const FeatureBlueprintContext = React.createContext();